import { getSavedState, saveState } from '@state/helpers'

export const state = {
  selectedPersonnelOffice: getSavedState('personnel.selectedPersonnelOffice'),
}

export const getters = {
  selectedPersonnelOffice(state) {
    return state.selectedPersonnelOffice
  },
}

export const mutations = {
  SET_SELECTED_PERSONNEL_OFFICE(state, office) {
    state.selectedPersonnelOffice = office
    saveState('personnel.selectedPersonnelOffice', office)
  },
}
